import React, { useState, createContext, useContext } from "react";
import Toast from "./Toast";

const ToastContext = createContext();
export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = "info", duration = 3000) => {
    const id = crypto.randomUUID(); // Generates a unique identifier
    setToasts((prev) => [...prev, { id, message, type }]);
  
    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, duration);
  };
  
  

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="toast_container">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            // onClose={() =>
            //   setToasts((prev) => prev.filter((t) => t.id !== toast.id))
            // }
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};
